module.exports = __webpack_public_path__ + "img/store-roles.30ee539a.svg";